export const allLocations = [
  { value: 'songea', label: 'SONGEA' },
  { value: 'moshi', label: 'MOSHI' },
  { value: 'dodoma', label: 'DODOMA' },
  { value: 'mwanza', label: 'MWANZA' },
  { value: 'dar-es-salaam', label: 'DAR ES SALAAM', aliases: ['dar', 'dsm'] },
  { value: 'tunduma', label: 'TUNDUMA' },
  { value: 'mbeya', label: 'MBEYA' },
  { value: 'chunya', label: 'CHUNYA' },
  { value: 'iringa', label: 'IRINGA' },
  { value: 'makambako', label: 'MAKAMBAKO' },
  { value: 'njombe', label: 'NJOMBE' },
  { value: 'mbinga', label: 'MBINGA' },
  { value: 'arusha', label: 'ARUSHA' },
  { value: 'mtwara', label: 'MTWARA' },
  { value: 'masasi', label: 'MASASI' },
  { value: 'tunduru', label: 'TUNDURU' },
  { value: 'mafinga', label: 'MAFINGA' },
  { value: 'morogoro', label: 'MOROGORO' },
  { value: 'shinyanga', label: 'SHINYANGA' },
  { value: 'singida', label: 'SINGIDA' },
  { value: 'manyoni', label: 'MANYONI' },
  { value: 'nzega', label: 'NZEGA' },
  { value: 'igunga', label: 'IGUNGA' },
  { value: 'tabora', label: 'TABORA' },
  { value: 'babati', label: 'BABATI' },
  { value: 'mikumi', label: 'MIKUMI' },
  { value: 'itigi', label: 'ITIGI' },
  { value: 'msamvu', label: 'MSAMVU' }
];

const outboundRoutes = [
  { from: 'SONGEA', to: 'MOSHI', price: 'TSh 90,000', durationKey: 'tenHours', fromValue: 'songea', toValue: 'moshi' },
  { from: 'SONGEA', to: 'DODOMA', price: 'TSh 54,000', durationKey: 'eightHours', fromValue: 'songea', toValue: 'dodoma' },
  { from: 'SONGEA', to: 'MWANZA', price: 'TSh 105,000', durationKey: 'twelveHours', fromValue: 'songea', toValue: 'mwanza' },
  { from: 'SONGEA', to: 'DAR ES SALAAM', price: 'TSh 68,000', durationKey: 'twelveHours', fromValue: 'songea', toValue: 'dar-es-salaam' },
  { from: 'SONGEA', to: 'TUNDUMA', price: 'TSh 42,000', durationKey: 'fiveHours', fromValue: 'songea', toValue: 'tunduma' },
  { from: 'SONGEA', to: 'MBEYA', price: 'TSh 35,000', durationKey: 'sixHours', fromValue: 'songea', toValue: 'mbeya' },
  { from: 'SONGEA', to: 'CHUNYA', price: 'TSh 35,000', durationKey: 'sixHours', fromValue: 'songea', toValue: 'chunya' },
  { from: 'SONGEA', to: 'IRINGA', price: 'TSh 35,000', durationKey: 'fiveHours', fromValue: 'songea', toValue: 'iringa' },
  { from: 'SONGEA', to: 'MAKAMBAKO', price: 'TSh 22,000', durationKey: 'fourHours', fromValue: 'songea', toValue: 'makambako' },
  { from: 'SONGEA', to: 'NJOMBE', price: 'TSh 17,000', durationKey: 'threeHours', fromValue: 'songea', toValue: 'njombe' },
  { from: 'SONGEA', to: 'MBINGA', price: 'TSh 8,000', durationKey: 'threeHours', fromValue: 'songea', toValue: 'mbinga' },
  { from: 'SONGEA', to: 'ARUSHA', price: 'TSh 85,000', durationKey: 'tenHours', fromValue: 'songea', toValue: 'arusha' },
  { from: 'SONGEA', to: 'MTWARA', price: 'TSh 49,000', durationKey: 'eightHours', fromValue: 'songea', toValue: 'mtwara' },
  { from: 'SONGEA', to: 'MASASI', price: 'TSh 35,000', durationKey: 'sixHours', fromValue: 'songea', toValue: 'masasi' },
  { from: 'SONGEA', to: 'TUNDURU', price: 'TSh 20,000', durationKey: 'fiveHours', fromValue: 'songea', toValue: 'tunduru' },
  { from: 'SONGEA', to: 'MAFINGA', price: 'TSh 32,000', durationKey: 'fiveHours', fromValue: 'songea', toValue: 'mafinga' },
  { from: 'SONGEA', to: 'MOROGORO', price: 'TSh 58,000', durationKey: 'tenHours', fromValue: 'songea', toValue: 'morogoro' },
  { from: 'SONGEA', to: 'SHINYANGA', price: 'TSh 95,000', durationKey: 'twelveHours', fromValue: 'songea', toValue: 'shinyanga' },
  { from: 'SONGEA', to: 'SINGIDA', price: 'TSh 70,000', durationKey: 'tenHours', fromValue: 'songea', toValue: 'singida' },
  { from: 'SONGEA', to: 'MANYONI', price: 'TSh 60,000', durationKey: 'eightHours', fromValue: 'songea', toValue: 'manyoni' },
  { from: 'SONGEA', to: 'NZEGA', price: 'TSh 85,000', durationKey: 'tenHours', fromValue: 'songea', toValue: 'nzega' },
  { from: 'SONGEA', to: 'IGUNGA', price: 'TSh 80,000', durationKey: 'tenHours', fromValue: 'songea', toValue: 'igunga' },
  { from: 'SONGEA', to: 'TABORA', price: 'TSh 88,000', durationKey: 'twelveHours', fromValue: 'songea', toValue: 'tabora' },
  { from: 'SONGEA', to: 'BABATI', price: 'TSh 82,000', durationKey: 'tenHours', fromValue: 'songea', toValue: 'babati' },
  { from: 'SONGEA', to: 'MIKUMI', price: 'TSh 48,000', durationKey: 'eightHours', fromValue: 'songea', toValue: 'mikumi' },
  { from: 'SONGEA', to: 'ITIGI', price: 'TSh 62,000', durationKey: 'eightHours', fromValue: 'songea', toValue: 'itigi' },
  { from: 'SONGEA', to: 'MSAMVU', price: 'TSh 58,000', durationKey: 'tenHours', fromValue: 'songea', toValue: 'msamvu' }
];

export const routeDefinitions = [
  ...outboundRoutes,
  ...outboundRoutes.map((route) => ({
    from: route.to,
    to: route.from,
    price: route.price,
    durationKey: route.durationKey,
    fromValue: route.toValue,
    toValue: route.fromValue
  }))
];
